export default __webpack_public_path__ + "static/media/thumbs-down-icon.2c003add.svg";